import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { Constants } from 'src/app/constants/constants';
import { DtRowModel } from 'src/app/models/datatable/dt_row.model';


@Component({
  selector: 'modal-address',
  templateUrl: './modal-new-organisation.component.html',
  styleUrls: ['./modal-new-organisation.component.scss'],
})
export class ModalNewOrganisationComponent implements OnInit {

  newAddress: DtRowModel;
  nameError: boolean = false;
  lineOneError: boolean = false;
  lineTwoError: boolean = false;
  cityError: boolean = false;
  postCodeError: boolean = false;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {
    this.newAddress = new DtRowModel();
    this.newAddress.addressName = "";
    this.newAddress.addressOne = "";
    this.newAddress.addressTwo = "";
    this.newAddress.addressCity = "";
    this.newAddress.addressPostCode = "";
  }


  ionViewWillEnter()
  {

  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'NewOrganisationModal');
  }


  createNewOrganisation()
  {
    var errorFound = false;
    this.nameError = this.lineOneError = this.lineTwoError = this.cityError = this.postCodeError = false;

    if (this.newAddress.addressName == "")
    {
      this.nameError = true;
      errorFound = true;
    }

    if (this.newAddress.addressOne == "")
    {
      this.lineOneError = true;
      errorFound = true;
    }

    if (this.newAddress.addressTwo == "")
    {
      this.lineTwoError = true;
      errorFound = true;
    }

    if (this.newAddress.addressCity == "")
    {
      this.cityError = true;
      errorFound = true;
    }

    if (this.newAddress.addressPostCode == "")
    {
      this.postCodeError = true;
      errorFound = true;
    }

    if (errorFound)
    {
      return;
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.clientService.createNewOrganisation(this.newAddress).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.modalController.dismiss(response.Organisations, null, 'NewOrganisationModal');

          this.appearanceService.presentToast("Organisation added.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }

      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }
}
